import { Col, Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";

export const Dashboard = () => {
  const navigate = useNavigate();
  return (
    <div>
      {" "}
      {/* // <Container style={{ width: "100%", margin: "30px 10px 10px 10px" }}> */}
      <Row>
        <Col>
          <h2> Coozmoo Digital Solutions Tools </h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card
            // style={{ background: "#e7e7e7" }}
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/meta-tags-generator")}
          >
            <Card.Body>
              <Card.Title>Meta Tags Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Generate SEO-Optimized meta titles and descriptions based on the
                targeted keyword.
              </Card.Text>
              {/* <Card.Link href="/meta-tags-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/header-tags-generator")}
          >
            <Card.Body>
              <Card.Title>Header Tags Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Smart tool to generate optimized H1, H2, H3 headings for your
                article or content with ease.
              </Card.Text>
              {/* <Card.Link href="/header-tags-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/rewrite-optimize-content")}
          >
            <Card.Body>
              <Card.Title>Rewrite Content with AI</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Smart tool to rewrite articles or content. Paste text to
                rephrase it in different languages.
              </Card.Text>
              {/* <Card.Link href="/rewrite-optimize-content">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/marketing-roi-calculator")}
          >
            <Card.Body>
              <Card.Title>Marketing ROI Calculator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Calculate and analyze your marketing campaign performance to
                improve results and ROI.
              </Card.Text>
              {/* <Card.Link href="/marketing-roi-calculator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/hooks-generator")}
          >
            <Card.Body>
              <Card.Title>Hooks Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Create captivating hooks that spark curiosity and engage your
                target audience instantly.
              </Card.Text>
              {/* <Card.Link href="/hooks-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/seo-graded-content-analyzer")}
          >
            <Card.Body>
              <Card.Title>SEO Content Grader</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Analyze content for AI generation and assess its SEO
                optimization quality effectively.
              </Card.Text>
              {/* <Card.Link href="/seo-graded-content-analyzer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/seo-website-audit")}
          >
            <Card.Body>
              <Card.Title>SEO Website Audit</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Detect AI-generated content and evaluate its SEO quality for
                better performance insights.
              </Card.Text>
              {/* <Card.Link href="/seo-website-audit">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/hashtag-generator")}
          >
            <Card.Body>
              <Card.Title>Generate hashtags and Caption</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Generate catchy captions and trending hashtags to boost
                engagement!
              </Card.Text>
              {/* <Card.Link href="/hashtag-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/density-checker")}
          >
            <Card.Body>
              <Card.Title>Keyword Density Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Use this tool to analyze keyword density in your content and
                assess SEO optimization.
              </Card.Text>
              {/* <Card.Link href="/density-checker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/faqs-generator")}
          >
            <Card.Body>
              <Card.Title>AI FAQ Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                The smartest tool to generate relevant FAQs automatically based
                on your topic or content.
              </Card.Text>
              {/* <Card.Link href="/faqs-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/social-headlines-generator")}
          >
            <Card.Body>
              <Card.Title>Social Headlines Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                The smartest tool to generate social headlines automatically
                based on your topic or keywords.
              </Card.Text>
              {/* <Card.Link href="/social-headlines-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/blog-generator")}
          >
            <Card.Body>
              <Card.Title>Blog Writer</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Create high-quality blog posts easily by harnessing the power of
                Artificial Intelligence.
              </Card.Text>
              {/* <Card.Link href="/blog-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/broken-link-checker")}
          >
            <Card.Body>
              <Card.Title>Broken Link Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Quickly identify and fix broken links on your website to boost
                SEO and user experience.
              </Card.Text>
              {/* <Card.Link href="/broken-link-checker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/jpg-to-png-convert")}
          >
            <Card.Body>
              <Card.Title>JPG to PNG Converter</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Convert JPG images to PNG format quickly with zero quality loss
                and fast processing.
              </Card.Text>
              {/* <Card.Link href="/jpg-to-png-convert">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/password-generator")}
          >
            <Card.Body>
              <Card.Title>Password Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Instantly generate secure, random passwords online with the
                Coozmoo Password Generator.
              </Card.Text>
              {/* <Card.Link href="/password-generator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/word-counter")}
          >
            <Card.Body>
              <Card.Title>Word Counter</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Quickly analyze your text and receive accurate, actionable
                insights with clear reports.
              </Card.Text>
              {/* <Card.Link href="/word-counter">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/robots_validate")}
          >
            <Card.Body>
              <Card.Title>Robots.txt Testing & Validation</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Validate and test your robots.txt file for optimal search
                crawling.
              </Card.Text>
              {/* <Card.Link href="/robots_validate">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/sero-preview-simulator")}
          >
            <Card.Body>
              <Card.Title>SERP Preview Simulator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                {" "}
                Simulate and preview your webpage’s appearance in search engine
                results for better SEO.
              </Card.Text>
              {/* <Card.Link href="/sero-preview-simulator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/redirect-checker")}
          >
            <Card.Body>
              <Card.Title>Website Redirect Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Analyze your website's redirect chain and optimize it to improve
                overall performance.
              </Card.Text>
              {/* <Card.Link href="/redirect-checker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/roas-calculator")}
          >
            <Card.Body>
              <Card.Title>ROAS Calculator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Calculate and optimize your Return on Ad Spend (ROAS) quickly
                and efficiently.
              </Card.Text>
              {/* <Card.Link href="/roas-calculator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/domain-checker")}
          >
            <Card.Body>
              <Card.Title>Domain Age Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Quickly find out website ages in bulk. Enter URLs and check
                domain creation dates fast.
              </Card.Text>
              {/* <Card.Link href="/domain-checker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/color-picker")}
          >
            <Card.Body>
              <Card.Title>Color Picker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Easily select and customize colors to perfectly match your
                design projects and needs.
              </Card.Text>
              {/* <Card.Link href="/color-picker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/cpc-calculator")}
          >
            <Card.Body>
              <Card.Title>CPC Calculator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Calculate Cost Per Click (CPC) accurately to optimize and
                improve your ad campaigns.
              </Card.Text>
              {/* <Card.Link href="/cpc-calculator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/cpm-calculator")}
          >
            <Card.Body>
              <Card.Title>CPM Calculator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Calculate Cost Per Mille (CPM) accurately to optimize and
                measure your ad impressions.
              </Card.Text>
              {/* <Card.Link href="/cpm-calculator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* New Row for Additional Tools */}
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/crc-calculator")}
          >
            <Card.Body>
              <Card.Title>CRC Calculator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Calculate Customer Retention Cost (CRC) to improve your business
                strategy.
              </Card.Text>
              {/* <Card.Link href="/crc-calculator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/ctr-calculator")}
          >
            <Card.Body>
              <Card.Title>CTR Calculator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Calculate Click-Through Rate (CTR) accurately to evaluate and
                boost your campaign success.
              </Card.Text>
              {/* <Card.Link href="/ctr-calculator">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/heading-tags-checker")}
          >
            <Card.Body>
              <Card.Title>Heading Tags Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Analyze heading tags effectively to enhance SEO and strengthen
                your content structure.
              </Card.Text>
              {/* <Card.Link href="/heading-tags-checker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/image-format-converter")}
          >
            <Card.Body>
              <Card.Title>Image Format Converter</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Convert images quickly and easily between various formats to
                suit all your needs.
              </Card.Text>
              {/* <Card.Link href="/image-format-converter">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/image-optimizer")}
          >
            <Card.Body>
              <Card.Title>Image Optimizer</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Optimize images to enhance loading speed and boost overall SEO
                performance effectively.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/reverse-image-search")}
          >
            <Card.Body>
              <Card.Title>Reverse Image Search</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Quickly find similar images or sources online using powerful
                reverse image search tools.
              </Card.Text>
              {/* <Card.Link href="/reverse-image-search">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/http-status-tool")}
          >
            <Card.Body>
              <Card.Title>Http Status Tool</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Effortlessly check any domain’s HTTP status and gain valuable
                insights for better decisions.
              </Card.Text>
              {/* <Card.Link href="/http-status-tool">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          {/* <Card className="CDS-Tools-Card-Hover">
            <Card.Body>
              <Card.Title>SEO Graded Content Analyzer</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                
                Analyze your content to determine if it was generated by AI and
                assess its SEO optimization quality.
              </Card.Text>
              <Card.Link href="/seo-graded-content">Explore</Card.Link>
            </Card.Body>
          </Card> */}
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/page-speed-checker")}
          >
            <Card.Body>
              <Card.Title>Page Speed Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Quickly analyze your website speed and uncover insights to boost
                performance effectively.
              </Card.Text>
              {/* <Card.Link href="/page-speed-checker">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row style={{ marginTop: "10px" }}>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/hex-to-rgb")}
          >
            <Card.Body>
              <Card.Title>HEX to RGB</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>

                Easily convert color codes in real-time with this simple and intuitive online tool.

              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>

          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/site-map-checker")}
          >
            <Card.Body>
              <Card.Title>Sitemap Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Enter your website URL to check whether an XML sitemap exists
                and is accessible.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/site-map-validator")}
          >
            <Card.Body>
              <Card.Title>Sitemap Validator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                This tool checks if your XML sitemap is formatted correctly and
                lists all nested files.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
        <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/outline-generator")}
          >
            <Card.Body>
              <Card.Title>Free AI Outline Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Quickly turn rough ideas into a clear, well-structured outline with this powerful tool.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
<Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/robots-txt-generator")}
          >
            <Card.Body>
              <Card.Title>Robots.txt Generator</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Easily manage crawling and indexing settings for smarter SEO using the powerful robots.txt tool.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
          
        </Col>
        <Col>
          <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/website-authority-checker")}
          >
            <Card.Body>
              <Card.Title>Website Authority Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Enter a domain name to analyze its authority, SEO credibility, ranking signals, and overall online strength.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>

        <Col>
        <Card
            className="CDS-Tools-Card-Hover"
            onClick={() => navigate("/backlink-checker")}
          >
            <Card.Body>
              <Card.Title>Backlink Checker</Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Text>
                Enter a domain to find backlinks, competitors, and link-building opportunities.
              </Card.Text>
              {/* <Card.Link href="/image-optimizer">Explore</Card.Link> */}
            </Card.Body>
          </Card>
        </Col>
        <Col>
        </Col>
      </Row>
      
    </div>
  );
};
